import { m } from 'framer-motion';

interface CategoryChipProps {
  icon: string;
  title: string;
  color: string;
  active: boolean;
  onClick?: () => void;
}

// Shared pill-shaped category tile — same visual language as the landing
// screen's old category strip, so picking categories in the lobby or solo setup
// feels like a continuation of the same UI instead of a different one.
export function CategoryChip({ icon, title, color, active, onClick }: CategoryChipProps) {
  return (
    <m.button
      data-testid="topic"
      onClick={onClick}
      whileTap={onClick ? { scale: 0.96 } : undefined}
      disabled={!onClick}
      style={{
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        gap: '0.75rem',
        flex: '0 0 auto',
        padding: '0.9rem 1.35rem',
        borderRadius: '100px',
        border: `2px solid ${active ? color : '#2E2B45'}`,
        background: active ? `linear-gradient(135deg, ${color}30, ${color}15)` : '#1B1830',
        boxShadow: active ? `0 0 16px ${color}40` : 'none',
        cursor: onClick ? 'pointer' : 'default',
        transition: 'border-color 0.2s, background 0.2s, box-shadow 0.2s',
      }}
    >
      {active && (
        <span style={{
          position: 'absolute',
          top: '-6px',
          right: '-6px',
          width: '20px',
          height: '20px',
          borderRadius: '50%',
          background: color,
          color: '#000',
          fontSize: '0.65rem',
          fontWeight: 700,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}>
          ✓
        </span>
      )}
      <span style={{ fontSize: '1.5rem', lineHeight: 1 }}>{icon}</span>
      <span style={{ fontSize: '1rem', fontWeight: 700, lineHeight: 1.3, color: active ? color : '#ccc' }}>{title}</span>
    </m.button>
  );
}
